<div *ngIf="this.items?.sideBannerList && this.items?.sideBannerList.length > 0">
  <div class="vertical-slider-container">
    <div class="vertical-slider right-adds" [@slideInOut]="animState">
      <ng-container *ngFor="let item of this.items?.sideBannerList">
        <div (click)="goToLink(item.Link)">
          <image-loader-utils [customUrl]="item.FileName" extraClasses="slide-image add" imageFormat="png"></image-loader-utils>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #staticImages>
  <div class="vertical-slider-container">
    <div class="vertical-slider-static right-adds">
      <ng-container *ngFor="let item of this.items?.sideBannerList">
        <image-loader-utils [customUrl]="item.FileName" extraClasses="static-image add" imageFormat="png"></image-loader-utils>
      </ng-container>
    </div>
  </div>
</ng-template>
